if (!customElements.get('story-grid')) {
  class StoryGrid extends HTMLElement {
    constructor () {
      super();

      this.storyCards = this.querySelectorAll('.story-card');
      this.tagFilters = this.querySelectorAll('.story-grid--tag-action');
      this.filter = 'featured';
    }
    connectedCallback() {
      this.addEventListener('click', (event) => {
        const elAction = event.target.closest('.story-grid--tag-action');
        if (elAction) {
          this.setFilter(elAction.dataset.tag);
          window.location.hash = this.filter;
          this.filterStories();
        }
      })

      if (window.location.hash) {
        this.setFilter(window.location.hash.replace('#', ''));
      }

      this.filterStories();
    }
    setFilter(newFilterValue) {
      // Are you setting an allowed value?
      const arrAllowedValues = [];
      [...this.tagFilters].forEach(elFilter => {
        arrAllowedValues.push(elFilter.dataset.tag);
      });

      if (arrAllowedValues.includes(newFilterValue)) {
        this.filter = newFilterValue;
      }
    }
    filterStories() {
      [...this.tagFilters].forEach(elFilter => {
        elFilter.dataset.tag === this.filter ? elFilter.classList.add('--active') : elFilter.classList.remove('--active');
      });
        
      [...this.storyCards].forEach(elCard => {
        elCard.dataset.tags.split(',').includes(this.filter) ? elCard.classList.remove('--hidden') : elCard.classList.add('--hidden');
      });
    }
  }
  customElements.define('story-grid', StoryGrid);
}